var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":_vm.$t('enterprise.message-subscription.message-guidelines'),"content-text":_setup.config.leaveWordTips,"button-text":_vm.$t('enterprise.message-subscription.submit')},on:{"button-click":_setup.goLeaveWord}})
}
var staticRenderFns = []

export { render, staticRenderFns }